'use client';

import Link from 'next/link';
import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import Container from '../Container';
import Image from 'next/image';

const Demo = () => {
  return (
    <section id="demo" className="py-20 text-black">
      <Container>
        <div className="mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
            Stop Overpaying for SEO Tools
            {/* Built by a founder tired of expensive SEO tools */}
          </h2>

          {/* Creator Story */}
          <div className="mb-12 flex flex-col md:flex-row items-start gap-6 md:gap-8 max-w-4xl mx-auto bg-gray-50 rounded-xl p-6">
            <div className="flex-shrink-0">
              <Image
                src="/images/eliana-photo.jpeg"
                alt="Eliana"
                width={100}
                height={100}
                className="w-24 h-24 rounded-full object-cover border-2 border-gray-300 shadow-md"
              />
            </div>
            <div className="text-left text-sm leading-relaxed">
              <p className="mb-3">
                <strong>Hey! I'm Eliana</strong>, a dive instructor turned coder. I built three SaaS products —{' '}
                <a href="https://scubareputation.com" target="_blank" rel="noopener noreferrer" className="text-emerald-600 underline hover:text-emerald-700">ScubaReputation</a>,{' '}
                <a href="https://peerquik.com" target="_blank" rel="noopener noreferrer" className="text-emerald-600 underline hover:text-emerald-700">PeerQuik</a>, and{' '}
                <a href="https://beunderwater.com" target="_blank" rel="noopener noreferrer" className="text-emerald-600 underline hover:text-emerald-700">BeUnderwater</a> — but I was tired of paying $99/month for basic SEO tools.
              </p>
              <p>
                So I built <strong>SEOZast</strong> — all the core features you actually need for just <span className="text-emerald-600 font-semibold">$19.99/month</span>. No more overpriced tools.{' '}
                <Link href="/articles/geo-vs-seo" className="text-emerald-600 underline hover:text-emerald-700">Learn about our GEO (AI search) optimization</Link>.
              </p>
            </div>
          </div>

          {/* Demo Video */}
          <div className="mb-12 text-center">
            <div className="relative w-full max-w-3xl mx-auto">
              <div className="aspect-[16/9] rounded-xl overflow-hidden shadow-2xl">
                <iframe
                  className="w-full h-full"
                  src="https://www.youtube.com/embed/JAbZmUaBA7E"
                  title="SEOZast Demo Video"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
            <p className="text-sm text-gray-500 mt-4">
              See how SEOZast goes from keyword to GitHub deploy in 30 seconds.
            </p>
          </div>

          {/* Social Proof */}
          <div className="text-center bg-white rounded-xl p-6 shadow-sm border max-w-2xl mx-auto">
            <div className="flex items-center justify-center mb-4">
              {[...Array(5)].map((_, i) => (
                <FaCheckCircle key={i} className="text-emerald-500 text-lg mx-1" />
              ))}
            </div>
            <p className="text-lg text-gray-700 font-medium italic mb-2">
              "Finally, an SEO tool that doesn't break the bank."
            </p>
            <p className="text-sm text-gray-500">
              Perfect for startups and solo devs tired of overpriced tools.
            </p>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Demo;

// 'use client';

// import Link from 'next/link';
// import React from 'react';
// import { FaCheckCircle } from 'react-icons/fa';
// import Container from '../Container';
// import Image from 'next/image';

// const Demo = () => {
//   return (
//     <section id="demo" className="py-20 text-black">
//       <Container>
//         <div className="mx-auto px-4 sm:px-6 lg:px-8">
//           <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
//             Automate Boring Tasks like SEO & GEO
//           </h2>
//           <div className="mb-12 flex flex-col md:flex-row items-start gap-6 md:gap-8 max-w-3xl mx-auto">
//             <div className="flex-shrink-0">
//               <Image
//                 src="/images/eliana-photo.jpeg"
//                 alt="Eliana"
//                 width={100}
//                 height={100}
//                 className="w-24 h-24 rounded-full object-cover border-2 border-gray-300 shadow-md"
//               />
//             </div>
//             <div className="text-left">
//               <p className="text-sm mb-3 leading-relaxed">
//                 <strong>Hey! I'm Eliana</strong>, a dive instructor turned coder who builds apps 🚀. I created three SaaS products —
//                 <a
//                   href="https://scubareputation.com"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="text-emerald-400 underline hover:text-emerald-500"
//                 >
//                   ScubaReputation
//                 </a>,{' '}
//                 <a
//                   href="https://peerquik.com"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="text-emerald-400 underline hover:text-emerald-500"
//                 >
//                   PeerQuik
//                 </a>,{' '}
//                 and{' '}
//                 <a
//                   href="https://beunderwater.com"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="text-emerald-400 underline hover:text-emerald-500"
//                 >
//                   BeUnderwater
//                 </a>{' '}
//                 — but got tired of expensive SEO tools and endless keyword research.
//               </p>
//               <p className="text-sm leading-relaxed">
//                 With more people searching on AI platforms like ChatGPT and Perplexity than Google, I built{' '}
//                 <strong>SEOZast</strong> to make SEO and GEO affordable for everyone. Analyze, find keywords, generate AI articles optimized for search engines and AI platforms, with automatic backlinks, and deploy to GitHub or download — all for just $5.99/month.{' '}
//                 <Link
//                   href="/articles/geo-vs-seo"
//                   className="text-emerald-400 underline hover:text-emerald-500"
//                 >
//                   Learn how SEOZast supports GEO
//                 </Link>.
//               </p>
//             </div>
//           </div>

//           <div className="mb-12">
//             <div className="relative w-full max-w-lg mx-auto aspect-[16/9]">
//               <iframe
//                 className="w-full h-full rounded-lg"
//                 src="https://www.youtube.com/embed/-GngvyA8AtA"
//                 title="SEOZast Demo Video"
//                 allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                 allowFullScreen
//               ></iframe>
//             </div>
//             <p className="text-md mt-8 text-center text-gray-400 font-medium italic">
//               <span className="text-emerald-400 text-xl">"</span>Made for startups tired of overpriced SEO and GEO tools
//               <span className="text-emerald-400 text-xl">"</span>.
//             </p>
//           </div>
//           <p className="text-center text-gray-600 text-sm">
//             Pair with{' '}
//             <Link
//               href="https://peerquik.com"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="text-emerald-400 hover:underline font-medium"
//             >
//               PeerQuik
//             </Link>{' '}
//             for rapid B2B/B2C launches.
//           </p>
//         </div>
//       </Container>
//     </section>
//   );
// };

// export default Demo;